<template>
  <div class="mb-5 text-center position-relative">
    <router-link :to="{ name: 'Home' }" class="mb-4 mx-auto d-table">
      <img
        src="@assets/img/logo-lg--colored.png"
        alt="LimeIQ"
        class="form-logo"
        width="401"
        height="120"
      />
    </router-link>
    <Bookmark
      v-if="bookmarkable"
      :title="route.name"
      :url="docURL"
      class="mr-2 position-absolute top-0 right-0"
    />
    <h2 class="text-primary">
      <slot>Welcome to LimeIQ!</slot>
    </h2>
    <slot name="sub-heading"></slot>
  </div>
</template>

<script>
import { defineComponent } from '@vue/composition-api'
import { useRoute } from 'vue2-helpers/vue-router'

import Bookmark from '@components/Bookmark'

export default defineComponent({
  name: 'FormHeader',
  components: {
    Bookmark
  },
  props: {
    bookmarkable: Boolean
  },
  setup() {
    const route = useRoute()

    const docURL = document.URL

    return {
      route,
      docURL
    }
  }
})
</script>

<style scoped>
img {
  max-width: 100%;
}
</style>
